<template>
  <ProjectFeature class="checkpoint-feature" background-image="/assets/checkpoint/checkpoint-bg.webp" left-border-right="#e70c5c 8px solid">
    <template #left-header>
      <div class="feature-logo">
        <h2>CheckPoint Live Event</h2>
      </div>
    </template>

    <template #left-body>
      <div class="feature-list">
        <ul>
          <li>
            Delivered a
            <b>fully immersive, multi-modal conference experience</b>
            for hundreds onsite and online using the
            <b>ZEN3</b>
            platform
          </li>
          <li>
            Combined branded
            <b>projection-mapped visuals</b>
            , a massive
            <b>real-time virtual environment</b>
            , and an
            <b>interactive digital twin</b>
            for remote attendees
          </li>
          <li>
            Enabled
            <b>real-time engagement</b>
            with check-in tracking, mobile polling, instant audience reactions, and live integration of a
            <b>Microsoft Teams feed</b>
          </li>
        </ul>
      </div>
    </template>

    <template #right-media>
      <div class="video-container">
        <ProjectFeatureMedia class="checkpoint-video-player" video-url="https://zen.zenapptic.ai/video/CheckPointEngageVideo.mp4" placeholder-text="See the experience in action" poster="/assets/checkpoint/engage-1.webp">
          <img class="video-preview" src="/assets/checkpoint/engage-1.webp" alt="Checkpoint Engage video preview" />
        </ProjectFeatureMedia>
      </div>
    </template>
  </ProjectFeature>
</template>

<style lang="scss">
.checkpoint-feature {
  overflow: hidden;

  .project-feature__left {
    @media (max-width: 767px) {
      border-width: 0;
    }
  }

  .project-feature__right {
    @media (max-width: 1024px) {
      overflow: visible;
    }
  }

  .feature-logo {
    padding: 3rem 0;

    @media (max-width: 767px) {
      padding: 2rem 0;
    }

    img {
      width: 100%;
    }

    h2 {
      color: white;
      font-size: 6.5rem;
      font-weight: 600;
      letter-spacing: -0.03em;
      line-height: 1;
      margin: 0;
    }
  }

  .feature-list {
    background-color: rgba(231, 12, 92, 0.8);
    padding: 2rem 2rem 2rem 1rem;

    @media (max-width: 767px) {
      padding: 2rem 1rem 2rem 0.25rem;
    }

    ul {
      display: flex;
      flex-direction: column;
      font-weight: 200;
      gap: 3rem;

      b {
        font-weight: 700;
      }

      @media (max-width: 767px) {
        font-size: 1.9rem;
        gap: 2rem;
      }
    }
  }

  .video-container {
    flex: 1 1 auto;
    height: auto;
    max-width: 100%;
    min-height: 0;
    position: relative;

    .checkpoint-video-player {
      height: 100%;
      max-width: none;
      width: 100%;
    }

    .video-placeholder {
      height: 100%;
      max-width: none;
      width: 100%;
    }

    .video-preview {
      display: block;
      height: 100%;
      min-height: 0;
      object-fit: cover;
      pointer-events: none;
      width: 100%;
    }
  }
}
</style>
